<template>
  <div class="dados-progress" role="status" aria-live="polite">
    <div class="dados-progress__resumo">
      <div class="dados-progress__copy">
        <span class="dados-progress__etapa"
          >Etapa {{ etapaAtual }} de {{ totalEtapas }}</span
        >
        <strong class="dados-progress__titulo">{{ titulo }}</strong>
      </div>
    </div>
    <div class="dados-progress__trilha" aria-hidden="true">
      <span class="dados-progress__barra" :style="{ width: progresso + '%' }" />
    </div>
    <div v-if="exibirContador" class="dados-progress__detalhe">
      <i
        class="mdi mdi-check-circle-outline dados-progress__icone"
        aria-hidden="true"
      ></i>
      <span class="dados-progress__contador"
        >{{ preenchidos }} de {{ totalGeral }} campos preenchidos</span
      >
    </div>
  </div>
</template>

<script lang="js">
/**
 * Cabeçalho de progresso do multi-step mobile da aba Dados.
 * Só é exibido no mobile via CSS (`.dados-progress`).
 *
 * @prop {Number} etapaAtual - etapa atual (1-based) para exibição
 * @prop {Number} totalEtapas - total de etapas (5)
 * @prop {String} titulo - título da etapa (ex.: Identificação)
 * @prop {Number} preenchidos - nº de campos preenchidos (0-24)
 * @prop {Number} totalGeral - total de campos (24)
 * @prop {Boolean} exibirContador - exibe a linha de detalhe abaixo da barra
 *   (terceiros oculta; mantém só etapa/título/barra)
 */
export default {
  name: "DadosProgressHeader",

  props: {
    etapaAtual: {
      type: Number,
      required: true
    },
    totalEtapas: {
      type: Number,
      default: 5
    },
    titulo: {
      type: String,
      required: true
    },
    preenchidos: {
      type: Number,
      default: 0
    },
    totalGeral: {
      type: Number,
      default: 22
    },
    exibirContador: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    progresso() {
      if (!this.totalGeral) return 0;
      return Math.min(100, Math.round((this.preenchidos / this.totalGeral) * 100));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/_main";
@import "../../styles/components/_etapas";
</style>


